import { GeocodeMetadata } from "../../models/api/GeocodeMetadata";

export abstract class GeocodeService{

    abstract geocodeFromCoord(lat: number, long: number): Promise<GeocodeMetadata>
}